import { dev } from '$app/environment';
import { initPWA } from '/common/pwa';
import { isMobileDevice, logout, setUnauthorizedHandler } from '/util';
import { setError } from '/stores/error';
import { installInteractionTracker } from '/stores/interactionContext.js';
import '/stores/alert.js';

export async function init() {
  installInteractionTracker();
  if (!dev) initPWA();

  window.addEventListener('error', (event) => {
    if (!event.error || event.message === 'Script error.') return;
    setError({
      message: event.message || '예기치 않은 오류가 발생했습니다.',
      stack: event.error?.stack || '',
      source: 'uncaught',
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    setError({
      message: reason?.message || String(reason) || '비동기 작업 중 오류가 발생했습니다.',
      stack: reason?.stack || '',
      source: 'unhandledrejection',
    });
    event.preventDefault();
  });

  // Error 객체가 포함된 console.error만 수집한다.
  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError.apply(console, args);
    const error = args.find(arg => arg instanceof Error);
    if (error) setError({ message: error.message, stack: error.stack || '', source: 'console' });
  };

  // 첫 렌더 전에 기존 디바이스별 전역 스타일 중 하나만 로드한다.
  if (isMobileDevice()) {
    await import('/styles/global_mobile.css');
  } else {
    await import('/styles/global.css');
  }
  setUnauthorizedHandler(logout);
}

export function handleError({ error, status }) {
  // 잘못된 북마크의 404는 예외 수집 대상에서 제외한다.
  if (status !== 404) {
    setError({ message: error.message || '페이지를 불러오지 못했습니다.', stack: error.stack || '', source: 'navigation' });
  }
  return { message: '페이지를 불러오지 못했습니다.' };
}
